import QuantityProduct from './QuantityProduct'

class PrePhotoProduct extends QuantityProduct {
  static MINIMUM_QUANTITY = 5
}

export default PrePhotoProduct
